import Barcode from 'react-jsbarcode';
import { useState } from 'react';
// npm i html2canvas
import html2canvas from 'html2canvas';
import './style.css'

function BarcodeGen() {
  document.getElementsByTagName("body")[0].style.overflow = "auto";

  const [barValue, setBarValue] = useState('test');
  function generateBarcode() {
    let input = document.getElementById('barcodeInput').value;
    document.querySelector('.barcodeText').style.display = 'none';

    document.querySelector('.barcodeCanvas').style.display = 'block';
    document.querySelector('.barcodecss3').style.justifyContent = 'center';
    setBarValue(input);
  }
  function downloadBarcode() {
    html2canvas(document.querySelector('.barcodeCanvas')).then((canvas) => {
      const link = document.createElement('a');
      link.download = 'barcode.png';
      link.href = canvas.toDataURL();
      link.click();
    });
  }

  return (
    <>
     <div className="barcodecss1">
        <div className="barcodenav">
          <h2>BarCodeCraft</h2>
          <a>Home</a>
        </div>
        <div className="barcodecss7">
          <h1>Generate & Download Barcodes for Free</h1>
        </div>
        <div className="barcodecss2">
          <div className="barcodecss3">
            <h2 className="barcodeText">
              Your <br />
              barcode will <br /> appear here
            </h2>
            <div className="barcodeCanvas">
              <Barcode value={barValue} />
            </div>
          </div>
          <div className="barcodecss4">
            <input
              id="barcodeInput"
              type="text"
              placeholder="Enter Barcode Data..."
            />
            <button id="barcodeBtn1" onClick={generateBarcode}>
              Generate
            </button>
            <button id="barcodeBtn2" onClick={downloadBarcode}>
              Download
            </button>
          </div>
        </div>
        <div className="barcodecss7">
          <p>
            A barcode generator is a free and easy-to-use way to create barcodes
            for the items in your inventory. Follow 5 simple steps and get
            started right now.
          </p>
        </div>
        <p className="barcodetypenote">
          Note : On this site Code 39 Barcode's are generated and more will be
          available soon.
        </p>
        <div className="barcodecss5">
          <h2>How to generate Barcode's ?</h2>
          <div className="barcodecss6">
            <div className="barcodetypes">
              <h3>1. Add your barcode data.</h3>
              <p>
                Add barcode data in input with text "Enter Barcode Data..." ,
                you can add text as well as number's you wish to.
              </p>
            </div>
            <div className="barcodetypes">
              <h3>2. Generate Barcode.</h3>
              <p>
                Click on generate button which will create a barcode of the data
                you entered in input.
              </p>
            </div>
            <div className="barcodetypes">
              <h3>3. Download Barcode.</h3>
              <p>
                Click on download button and it will ask you where you want to
                download file, direct to where you want to download and click on
                save.
              </p>
            </div>
            <div className="barcodetypes">
              <h3>4. Generate New Barcode.</h3>
              <p>
                If you want to regenerate new barcode just add new data to input
                and click on generate.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BarcodeGen;
